module.exports = __webpack_public_path__ + "img/arrow-left.458dac6d.svg";